<!-- <ion-content> -->
  <div class="container-qr-code">
    <div class="dialog-title-row">
      <span></span>
      <button class="btn-close-dialog" mat-dialog-close><i class="fa-light fa-times"></i></button>
    </div>
    <p class="text-locator">
      {{qrTitle}}
    </p>
    <qrcode
    [qrdata]="localizador"
    [allowEmptyString]="true"
    [cssClass]="'center'"
    [colorDark]="'#ff4d80'"
    [colorLight]="'#ffffffff'"
    [elementType]="'canvas'"
    [errorCorrectionLevel]="'M'"
    [imageHeight]="75"
    [imageWidth]="75"
    [margin]="4"
    [scale]="1"
    [title]="qrTitle"
    [width]="300"
  ></qrcode>   
</div>
<!-- </ion-content> -->
